import automuestreador1 from '../automuestreador/automuestreador1.png'

const AutomuestreadorImages = [
    automuestreador1,
]

export default AutomuestreadorImages